<h1 mat-dialog-title class="z5-main-header" i18n>Update Email <small class="align-top">- {{dialogData.user.email}}</small></h1>

<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()" class="user-edit-form">
	<div mat-dialog-content class="main-content mb-2">
		<div class="row">
			<div class="col-12">
				<app-search-select
					[data]="dialogData.appKeys"
					[metaSort]="['provider']"
					[metaSearch]="['clientId', 'provider']"
					[(selected)]="dialogData.appKeyClientId"
					tooltip="Select an app key to manage users."
					i18n-tooltip
					title="Select App Key"
					i18n-title
				></app-search-select>
			</div>

			<div class="divider"></div>

			<!-- Email -->
			<div class="col-12">
				<mat-form-field appearance="standard" class="w-100 hover-suffix">
					<mat-label i18n>Email</mat-label>
					<input matInput type="email" placeholder="Email" i18n-placeholder formControlName="email" maxlength="255" />

					<span
						*ngIf="validatingInput && formInputs.get('email').value?.trim()"
						class="suffix-icon text-success"
						matSuffix
					>
						<img src="assets/loader-hor-dots.gif" class="spinner" alt="Loading" />
					</span>

					<mat-icon
						*ngIf="dialogData.user.validated && dialogData.user.email === formInputs.get('email').value && !validatingInput"
						aria-hidden="false"
						aria-label="Verified icon showing tooltip"
						class="suffix-icon text-success"
						matTooltip="Email has been verified."
						i18n-matTooltip
						matSuffix
					>check_circle</mat-icon>
					<mat-icon
						*ngIf="!dialogData.user.validated && dialogData.user.email === formInputs.get('email').value && !validatingInput"
						aria-hidden="false"
						aria-label="Verified icon showing tooltip"
						class="suffix-icon text-danger"
						matTooltip="Email has not been verified."
						i18n-matTooltip
						matSuffix
					>unpublished</mat-icon>
					<button
						class="suffix-icon"
						mat-icon-button
						type="button"
						title="Copy to clipboard"
						[appCopyToClipboard]="formInputs.get('email').value?.trim()"
						i18n-title
						matSuffix
						*ngIf="!validatingInput && formInputs.get('email').value?.trim()"
					>
						<span class="material-icons">content_copy</span>
					</button>

					<mat-error
						appFormErrorMessage
						[type]="formEditorInputType.email"
						[errorFormControl]="formInputs.controls.email"
					></mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>

	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-stroked-button
				mat-dialog-close
				i18n
				cdkFocusInitial
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				class="w-100 edit-email-submit"
				type="submit"
				mat-flat-button
				color="primary"
				[disabled]="formInputs.invalid || !dialogData.appKeyClientId"
				i18n
			>Save</button>
		</div>
	</div>
</form>
